import styles from './styles/FiltersSidebar.module.scss';
import React from 'react';
import { ScrollableContainer } from '../../../Components/react/ScrollableContainer';
import { ClearAllButton } from './ClearAllButton';
import { activeFacetConfigs, showFilterByTypes, typesFacetConfig } from '../../configs';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { ItemsList } from './Items.list';
import { FilterWrapper } from './FilterWrapper';
import { ItemsListHierarchy } from './Items.list.hierarchy';
import { ItemsColors } from './Items.colors';
import { ItemsIcons } from './Items.icons';
import { ItemsStatic } from './Items.static';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
import { FACET_KEY_TYPES } from '../../constants/facetKeys';
import { ItemsTypes } from './Items.types';
import { SkeletonFacet } from './Skeleton.facet';
export const FiltersSidebar = () => {
    const { hierarchyFacets, facets, hits } = useAlgoliaDataContext();
    if (MEDIA_BREAKPOINTS.XL_UP.matches && hits.length < 1) {
        return (React.createElement("div", { className: `ov:h ${styles.sidebarWrapper}` }, [...Array(4)].map((v, i) => React.createElement(SkeletonFacet, { key: i }))));
    }
    return (React.createElement("div", { className: `pos:f t:0 r:0 d:grid bxsh:2 w:100 ${styles.sidebarWrapper}` },
        React.createElement(ClearAllButton, null),
        React.createElement(ScrollableContainer, { className: styles.itemsContainer },
            MEDIA_BREAKPOINTS.MD_UP.matches &&
                showFilterByTypes &&
                facets[FACET_KEY_TYPES] !== undefined &&
                React.createElement(FilterWrapper, { fConfig: typesFacetConfig, key: FACET_KEY_TYPES },
                    React.createElement(ItemsTypes, null)),
            activeFacetConfigs.map(fConfig => {
                if (fConfig.style !== 'static_tree' &&
                    facets[fConfig.key] === undefined &&
                    hierarchyFacets[fConfig.key] === undefined)
                    return null;
                return (React.createElement(FilterWrapper, { fConfig: fConfig, key: fConfig.key }, (() => {
                    switch (fConfig.style) {
                        case 'list':
                            return fConfig.hierarchy !== undefined
                                ? React.createElement(ItemsListHierarchy, { fConfig: fConfig })
                                : React.createElement(ItemsList, { fConfig: fConfig });
                        case 'static_tree':
                            return React.createElement(ItemsStatic, null);
                        case 'colors':
                            return React.createElement(ItemsColors, { fConfig: fConfig });
                        case 'icons':
                            return React.createElement(ItemsIcons, { fConfig: fConfig });
                        default:
                            return null;
                    }
                })()));
            }))));
};
